import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "vc_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

// attach bearer token to every request
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// on auth failure for admin calls, clear token and bounce to login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && url.includes("/admin") && !url.includes("/admin/login")) {
      setToken("");
      if (!window.location.pathname.startsWith("/login")) window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

export async function adminLogin(username, password) {
  const r = await api.post("/admin/login", { username, password });
  return r.data;
}

export async function getSettings() { const r = await api.get("/settings"); return r.data; }
export async function createLead(payload) { const r = await api.post("/leads", payload); return r.data; }

// admin
export async function adminDashboard() { return (await api.get("/admin/dashboard")).data; }
export async function adminLeads(params) { return (await api.get("/admin/leads", { params })).data; }
export async function adminLead(id) { return (await api.get(`/admin/leads/${id}`)).data; }
export async function adminUpdateLead(id, body) { return (await api.patch(`/admin/leads/${id}`, body)).data; }
export async function adminAddActivity(id, text) { return (await api.post(`/admin/leads/${id}/activity`, { text })).data; }
export async function adminOperators(q) { return (await api.get("/admin/operators", { params: { q } })).data; }
export async function adminOperator(id) { return (await api.get(`/admin/operators/${id}`)).data; }
export async function adminAircraftSearch(q) { return (await api.get("/admin/aircraft-search", { params: { q } })).data; }
export async function adminAircraftOperators(code) { return (await api.get(`/admin/aircraft/${code}/operators`)).data; }
export async function adminAircraft() { return (await api.get("/admin/aircraft")).data; }
export async function adminUpdateAircraft(code, body) { return (await api.put(`/admin/aircraft/${code}`, body)).data; }
export async function adminGetSettings() { return (await api.get("/admin/settings")).data; }
export async function adminPutSettings(body) { return (await api.put("/admin/settings", body)).data; }
